import { render, staticRenderFns } from "./NileUg.vue?vue&type=template&id=6138eeb7&"
import script from "./NileUg.vue?vue&type=script&lang=js&"
export * from "./NileUg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports